import { styled } from 'libs/ui/styled';

export const HiddenBoxStyled = styled('div')<{ hidden: boolean }>(
  ({ hidden }) => ({
    ...(hidden && { display: 'none' }),
  })
);
